import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import { SalesOpportunity } from '../crm/crm-upboard/interfaces/sales-opportunity.interface';

@Injectable({
  providedIn: 'root'
})
export class SalesOpportunityService {

  // endpoints
  salesOpportunityEp: string = `${this._apiSvc.endpoints.crm}/api/SalesOpportunity`;

  constructor( private _apiSvc: ApiService) { }

  /**
 * Search sales opportunities
 * @param params 
 * @returns 
 */
  search(params: any): any {
    return this._apiSvc.search(this.salesOpportunityEp, params)
      .pipe(
        map((res: any) => {
          return res.Data;
        })
      );
  }

  /**
   * Get sales opportunity
   * @param id 
   * @returns 
   */
  get(id: number): any {
    return this._apiSvc.get(`${this.salesOpportunityEp}/${id}`);

  };

  /**
   * Get sales opportunity
   * @param id 
   * @returns 
   */
  getById(id: number): any {
    return this._apiSvc.get(`${this.salesOpportunityEp}/Get/${id}`);

  };

  /**
   * Get boolean indicating if sales opportunity is last remaining for an upboard person
   * @param id 
   * @returns 
   */
  getIsLastRemainingOpportunity(id: number): any {
    return this._apiSvc.get(`${this.salesOpportunityEp}/lastRemaining/${id}`);
  }

  /**
   * Add sales opportunity
   * @param params 
   * @returns 
   */
  add(params: SalesOpportunity): any {
    return this._apiSvc.add(this.salesOpportunityEp, params); 
  }

  /**
   * Update sales opportunity
   * @param params 
   * @returns 
   */
  update(params: SalesOpportunity): any {
    return this._apiSvc.update(`${this.salesOpportunityEp}/${params.Id}`, params);
  }

  /**
   * Reassign sales opportunity
   * @param salesOpportunityId 
   * @param salesPersonId
   * @returns 
   */
  reassign(salesOpportunityId: number, salesPersonId: number): any {
    return this._apiSvc.update(`${this.salesOpportunityEp}/${salesOpportunityId}/ReassignSalesOpportunity`, { SalesPersonId: salesPersonId });
  }

  /**
   * Get sales opportunity
   * @param id 
   * @returns 
   */
  getKeyInfoById(id: number): any {
    return this._apiSvc.get(`${this.salesOpportunityEp}/KeyInfo/${id}`);

  };

  // delete sales opportunity
  delete(id: number): any {
    return this._apiSvc.delete(`${this.salesOpportunityEp}/${id}`);
  }

}
